import {service3} from './const'

export const service=service3.split('').reverse().join('')